import PropTypes from 'prop-types';

import isNil from 'lodash/isNil';

import {isEmptyString} from '@utils/form-utils';

import ClientOrganizationLogo from './ClientOrganizationLogo';
import Crisis24Logo from './Crisis24Logo';

/**
 * If there is a client configured logo, return it, otherwise return the crisis24 logo
 * */
function SingleLogo(props) {
  const {clientLogoUrl, className, crisis24Logo} = props;

  const hasNoClientLogo = isNil(clientLogoUrl) || isEmptyString(clientLogoUrl);

  return (
    <>
      {hasNoClientLogo ? (
        <Crisis24Logo logo={crisis24Logo} />
      ) : (
        <ClientOrganizationLogo clientLogoUrl={clientLogoUrl} className={className} />
      )}
    </>
  );
}

SingleLogo.propTypes = {
  clientLogoUrl: PropTypes.string,
  className: PropTypes.string,
  crisis24Logo: PropTypes.string,
};

export default SingleLogo;
